import './Navbar.css'

function Navbar() {
    return (
        <div className="navbar">
            <div
                data-animation="default"
                data-collapse="medium"
                data-duration="400"
                data-easing="ease"
                data-easing2="ease"
                role="banner"
                className="navbar-container w-nav"
            >
                <div className="navbar-container-wrap">
                    <div className="navbar-wrapper">
                        <a href="/" aria-current="page" className="navbar-logo">
                            <div className="navbar-logo-card">
                                <img
                                    src='/code2-logo.svg'
                                    loading="lazy"
                                    alt=""
                                    className="navbar-brand-logo"
                                />
                                <span className="navbar-logo-text">Steady</span>
                            </div>
                        </a>
                        <div className="nav-right">
                            <div className="nav-button-wrapper">
                                <a href="/contact-us" className="sign-up-btn w-inline-block">
                                    <div className="button-1-text">Sign Up</div>
                                </a>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default Navbar;